import { Container, Divider, Paper } from '@mui/material';

import { ContainerWrapper } from '../styledComponents';

export const About = () => {
  return (
    <ContainerWrapper>
      <Container>
        <Paper className='paper' elevation={2}>
          <header>
            <h1>About the Rabbit Portal</h1>
            <Divider />
          </header>
          <main>
            <section>
              <header>
                <h2>VERIFYING CANDIDATES</h2>
              </header>
              <p>
                The Department of Defense (DOD) partnered with the Department of
                State (DOS) to assist with the employment verification portion
                of the Special Immigrant Visa (SIV) process for Afghan nationals
                who reported employment with DOD contractors. This effort is
                called Project Rabbit.
              </p>
              <p>
                Project Rabbit's goal is to streamline the collection of
                documents for Chief of Mission (COM) approval (Step 1 of the{' '}
                <a
                  target='_blank'
                  href='https://travel.state.gov/content/travel/en/us-visas/immigrate/special-immg-visa-afghans-employed-us-gov.html'
                  rel='noreferrer'
                >
                  Afghan SIV application process
                </a>
                ), by matching SIV applicants with human resource and employment
                data provided by DOD contractors. Project Rabbit provides this
                employment information to the Department of State to assist
                employment verification and the COM’s in determining whether the
                SIV applicant provided “faithful and valuable service” to the
                U.S. Government.
              </p>
            </section>
            <section>
              <header>
                <h2>FAQ</h2>
              </header>
              <p>
                <b>
                  1. Can someone apply for a Special Immigrant Visa through
                  Project Rabbit?
                </b>
                <br /> No, the Rabbit Portal is only for employers to use to
                provide information about existing SIV applicants who have
                already initiated a SIV application with the Department of
                State. Rabbit cannot be used to begin a new Afghan SIV
                application. For further information on starting a SIV
                application, please see travel.state.gov/afghan.
              </p>
              <p>
                <b>
                  2. My employees are not listed in the Rabbit Portal, what
                  should I do?
                </b>
                <br /> Reach out to your point of contact for Rabbit (the person
                who invited your organization to participate) and describe what
                you are seeing.
              </p>
              <p>
                <b>
                  3. I’m seeing candidates who did not work for me in the Rabbit
                  Portal, what should I do?
                </b>
                <br /> Reach out to your point of contact for Rabbit (the person
                who invited your organization to participate) and describe what
                you are seeing.
              </p>
              <p>
                <b>
                  4. Are other agencies/offices outside of DOD using Project
                  Rabbit?
                </b>
                <br /> Not at this time. Currently, Project Rabbit is only
                accepting information about employees of DOD contractors.
              </p>
              <p>
                <b>5. How does Project Rabbit work?</b>
              </p>
              <ol>
                <li>
                  <b>Step 1: Apply for a Special Immigrant Visa</b>
                </li>
                <ul>
                  <li>
                    The applicant needs to go to{' '}
                    <a
                      target='_blank'
                      href=' https://travel.state.gov/content/travel/en/us-visas/immigrate/special-immg-visa-afghans-employed-us-gov.html'
                    >
                      https://travel.state.gov/content/travel/en/us-visas/immigrate/special-immg-visa-afghans-employed-us-gov.html
                    </a>
                  </li>
                  <li>
                    The applicant should complete as much of the application as
                    possible (Form DS-157, evidence of nationality, biographic
                    data, copy of employee badge (if available), etc.)
                  </li>
                  <li>
                    If the applicant already has an employment verification
                    letter or a letter of recommendation, they should include
                    the letters in their application.
                  </li>
                  <li>
                    If the applicant has been unable to obtain an employment
                    verification letter or a letter of recommendation, they
                    should submit all other available documentation with their
                    application.
                  </li>
                  <li>
                    The applicant should NOT wait to apply just because they do
                    not have all the documentation.
                  </li>
                </ul>
                <li>
                  <b>
                    Step 2: Wait to receive a SIV case number from the State
                    Department’s National Visa Center (NVC)
                  </b>
                </li>
                <ul>
                  <li>
                    It typically takes up to 5-8 weeks for a case number to be
                    assigned.
                  </li>
                </ul>
                <li>
                  <b>
                    Step 3: Project Rabbit pulls active SIV cases from the State
                    Department on a recurring basis
                  </b>
                </li>
                <ul>
                  <li>
                    A SIV case is considered active after NVC assigns a case
                    number. Typically, these case numbers begin with “NVCSIV”
                    followed by 10 digits.
                  </li>
                  <li>
                    If an applicant’s employer is not already enrolled in
                    Project Rabbit, the employer will be contacted by our team
                    to enroll them in the program.
                  </li>
                  <li>
                    The applicant DOES NOT need to contact DOD or take any
                    action with DOD regarding Project Rabbit, but the Department
                    of State may request further information from the candidate
                    as part of the normal COM approval application process.
                  </li>
                </ul>
                <li>
                  <b>
                    Step 4: Project Rabbit requests employment data from
                    participating employers
                  </b>
                </li>
                <ul>
                  <li>
                    Participating employers will need to provide HR data and
                    employment records to complete the employment verification
                    data fields in the Rabbit Portal.
                  </li>
                  <li>
                    Participating employers will complete as many data fields as
                    possible for each SIV case they receive and submit the data
                    back within the Rabbit Portal.
                  </li>
                </ul>
                <li>
                  <b>
                    Step 5: Project Rabbit forwards employment verification data
                    to the State Department
                  </b>
                </li>
                <ul>
                  <li>
                    The State Department will review the Rabbit data, and any
                    other application data received to determine eligibility for
                    COM approval. The State Department will then issue a COM
                    decision letter to each applicant.
                  </li>
                </ul>
              </ol>

              <p>
                <b>
                  6. Does Project Rabbit expedite other Steps in the Afghan SIV
                  process or provide emergency assistance?
                </b>
                <br /> No, Project Rabbit only assists with the employment
                verification portion of the Chief of Mission (COM) approval
                application (Step 1 of the{' '}
                <a
                  target='_blank'
                  href='https://travel.state.gov/content/travel/en/us-visas/immigrate/special-immg-visa-afghans-employed-us-gov.html'
                  rel='noreferrer'
                >
                  Afghan SIV application process
                </a>
                ). Project Rabbit does not aid with additional Steps in the
                process or provide emergency assistance.
              </p>
            </section>
          </main>
        </Paper>
      </Container>
    </ContainerWrapper>
  );
};
